import type { Ticker } from '@cutr/constants/cutlist-theme.ts';
import { cutlistConfigs } from '@cutr/constants/cutlist-theme.ts';

export const getFeaturesForTheme = (ticker: Ticker) => {
  return cutlistConfigs[ticker].features;
};

// https://github.com/ComponentDriven/csf/blob/18dbdbe5682fff96c25edd263a306c5d0291870d/src/index.ts#L8
export const sanitize = (string: string) => {
  return string
    .toLowerCase()

    .replace(/[ ’–—―′¿'`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '-')
    .replace(/-+/g, '-')
    .replace(/^-+/, '')
    .replace(/-+$/, '');
};
